module.exports = __webpack_public_path__ + "static/img/6.3e23d3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/6.jpg
// module id = pjGs
// module chunks = 1